export const LEAD_TAGS = [
  { tag: "{{name}}", label: "Full name" },
  { tag: "{{first_name}}", label: "First name" },
  { tag: "{{company}}", label: "Company" },
  { tag: "{{phone}}", label: "Phone" },
  { tag: "{{email}}", label: "Email" },
  { tag: "{{city}}", label: "City" },
  { tag: "{{state}}", label: "State" },
  { tag: "{{zip}}", label: "ZIP" },
  { tag: "{{coverage}}", label: "Coverage" },
  { tag: "{{premium}}", label: "Premium est." },
  { tag: "{{industry}}", label: "Industry" },
  { tag: "{{employees}}", label: "# Employees" },
];

export const USER_TAGS = [
  { tag: "{{agent}}", label: "Your name" },
  { tag: "{{agent_email}}", label: "Your email" },
  { tag: "{{agent_phone}}", label: "Your phone" },
];

export const SCRIPT_TAGS = [...LEAD_TAGS, ...USER_TAGS];

export const fillScript = (body, lead, user) => {
  if (!body) return "";
  const coverage = ((lead?.insurance_types || [lead?.insurance_type]).filter(Boolean).join(", ") || "").replace(/_/g, " ");
  const map = {
    name: lead?.name || "",
    first_name: (lead?.name || "").split(" ")[0] || "",
    company: lead?.company || "",
    phone: lead?.phone || "",
    email: lead?.email || "",
    city: lead?.city || "",
    state: lead?.state || "",
    zip: lead?.zip || "",
    coverage,
    premium: lead?.premium_estimate != null ? `$${Number(lead.premium_estimate).toLocaleString("en-US")}` : "",
    industry: lead?.industry || "",
    employees: lead?.employees != null ? String(lead.employees) : "",
    agent: user?.name || "",
    agent_email: user?.email || "",
    agent_phone: user?.phone || "",
  };
  return body.replace(/\{\{\s*(\w+)\s*\}\}/g, (m, k) => (k in map ? map[k] : m));
};
